import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState, useRef} from "react";
import {getCartPageProducts, setCartPageDelete, setShopCartCount} from "store/MainSlice";
import styles from './style.module.css';
import MobileFooterCartProduct from "./MobileFooterCartProduct";
import langData from "lang/data";
import lang from "../../lang/lang";
import UseCalcPrice from "../../helpers/UseCalcPrice";

function MobileFooterCart({isOpen, setIsOpen}) {

    const {currentLanguage, currentCurrency} = useSelector(({main}) => main);

    const cardRef = useRef(null);

    const navigate = useNavigate();

    const cardData = {
        error: 0,
        cart: [
            {
                cart_id: 204305,
                coupon_discount: 0,
                seller_product: {
                    id: 38521,
                    product_id: 42003,
                    discount: 0,
                    discount_type: "1",
                    recommended_retail_price: null,
                    promo_price: null,
                    slug: "sfera-lite-bg1515",
                    thum_img: null,
                    stock_manage: 0,
                    status: 1,
                    recent_view: "2025-05-15 10:46:36",
                    total_sale: 0,
                    seller_product_sku_id: 38630,
                    seller_product_id: 38521,
                    flash_deal: null,
                    skus: [
                        {
                            id: 38630,
                            product_id: 38521,
                            selling_price: 69000,
                        },
                    ],
                    product: {
                        id: 42003,
                        product_type: 1,
                        brand_id: 1173,
                        online_price: 0,
                        product_name: "SFERA LITE BG1515",
                        li_product_id: 49656,
                        online_selling_price: null,
                        installing_price: 1500,
                        thumbnail_image_source: "uploads/images/03-06-2025/683eb88575c86.webp",
                        media_ids: "112696",
                        gift_ids: null,
                        gift_count: null,
                        guaranty: "",
                        status: 1,
                        installing_p: 0,
                        installation_p: 0,
                        brand: {
                            id: 1173,
                            logo: "img/brand/logo/1750331167.Mebeltorg_Svg.svg",
                            name: "MEBELTORG",
                            slug: "mebeltorg",
                            sticker_id: null,
                            installing_b: 0,
                            installation_b: 0,
                            sticker: null,
                        },
                        sticker: [],
                        gallary_images_api: [
                            {
                                product_id: 42003,
                                images_source: "uploads/images/03-06-2025/683eb88575c86.webp",
                                thum_image_sourc: "uploads/images/03-06-2025/683eb885b8f94.webp",
                                media_id: 112696,
                            },
                        ],
                    },
                    categories: [
                        {
                            name_en: "Chair Canes",
                            name_ru: "Подвесные кресла",
                            name_hy: "Ճոճաթոռներ",
                            installation: 1,
                            installing: 1,
                            sticker_id: null,
                            laravel_through_key: 42003,
                            sticker: null,
                        },
                    ],
                },
                qty: 1,
                installing: 0,
                installing_count: 0,
            },
            {
                cart_id: 204306,
                coupon_discount: 0,
                seller_product: {
                    id: 29629,
                    product_id: 33071,
                    discount: 0,
                    discount_type: "1",
                    recommended_retail_price: null,
                    promo_price: null,
                    slug: "gim63015uk",
                    thum_img: "uploads/images/13-02-2024/65cb1d0c86a52.webp",
                    stock_manage: 0,
                    status: 1,
                    recent_view: "2023-10-31 10:24:11",
                    total_sale: 0,
                    seller_product_sku_id: 29738,
                    seller_product_id: 29629,
                    flash_deal: null,
                    skus: [
                        {
                            id: 29738,
                            product_id: 29629,
                            selling_price: 79900,
                        },
                    ],
                    product: {
                        id: 33071,
                        product_type: 1,
                        brand_id: 268,
                        online_price: 0,
                        product_name: "GIM63015UK",
                        li_product_id: 40309,
                        online_selling_price: null,
                        installing_price: null,
                        thumbnail_image_source: "uploads/images/14-03-2026/69b570612e36e.webp",
                        media_ids: "122251,122250",
                        gift_ids: null,
                        gift_count: null,
                        guaranty: {
                            en: "6 months",
                            hy: "6 ամիս",
                            ru: "6 месяцев",
                        },
                        status: 1,
                        installing_p: 0,
                        installation_p: 0,
                        brand: {
                            id: 268,
                            logo: "img/brand/logo/1711803979.geepas.svg",
                            name: "GEEPAS",
                            slug: "geepas",
                            sticker_id: null,
                            installing_b: 0,
                            installation_b: 0,
                            sticker: null,
                        },
                        sticker: [],
                        gallary_images_api: [
                            {
                                product_id: 33071,
                                images_source: "uploads/images/05-09-2025/68ba8310f3e7d.webp",
                                thum_image_sourc: "uploads/images/05-09-2025/68ba831177b98.webp",
                                media_id: 122250,
                            },
                            {
                                product_id: 33071,
                                images_source: "uploads/images/14-03-2026/69b570612e36e.webp",
                                thum_image_sourc: "uploads/images/14-03-2026/69b570621b560.webp",
                                media_id: 122251,
                            },
                        ],
                    },
                    categories: [
                        {
                            name_en: "Ice Makers",
                            name_ru: "Льдогенератор",
                            name_hy: "Սառույց պատրաստող սարքեր",
                            installation: 1,
                            installing: 1,
                            sticker_id: null,
                            laravel_through_key: 33071,
                            sticker: null,
                        },
                    ],
                },
                qty: 1,
                installing: 1,
                installing_count: 0,
            },
        ],
        imagesPath: "https://vlv.am/public",
    };

    const dispatch = useDispatch();

    const {cartPageProducts, shopCartCount} = useSelector(({main}) => main);

    const [products, setProducts] = useState(null);

    useEffect(() => {
        dispatch(getCartPageProducts());
    }, []);

    useEffect(() => {
        if (cardRef.current) {

        }
    }, []);

    useEffect(() => {
        const productsArray = cartPageProducts?.cart?.map((product) => {
            let onlineSellingPrice = null; // Default value is null
            if (product?.seller_product?.product?.online_selling_price && product?.seller_product?.product?.online_price) {
                onlineSellingPrice =
                    product?.seller_product?.product?.online_selling_price;
            }
            return {
                id: product.seller_product.id,
                count: product.qty,
                installation_p: product?.seller_product?.product?.installation_p,
                installation_b: product?.seller_product?.product?.brand?.installation_b,
                installation: product?.seller_product?.categories?.[0]?.installation,
                haveInstalling: !!product?.seller_product?.product?.installing_price,
                installing: product.installing_count,
                installingPrice: product?.seller_product?.product?.installing_price,
                image: product?.seller_product?.product.thumbnail_image_source,
                brandName: product?.seller_product?.product?.brand?.name, //
                productName: product?.seller_product?.product.product_name, //
                promoPrice: product?.seller_product?.promo_price, //
                // averagePrice: product?.product?.average_price,
                OnlineSelingPrice: onlineSellingPrice,
                sellingPrice: product?.seller_product?.skus?.[0]?.selling_price, //
                sticker: product?.seller_product?.product?.sticker, //
                cartId: product.cart_id, //
                gift_images: product?.seller_product?.product?.gift_images, //
            };
        });
        setProducts(productsArray);
    }, [cartPageProducts]);

    useEffect(() => {
        if (!isOpen) return;
        const handleClickOutside = (event) => {
            if (cardRef.current && !cardRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, setIsOpen]);

    const totalPrice = products?.reduce((count, product) => {
        let total = 0;

        if (product?.installing) {
            total +=
                (product.count - product.installing) *
                ((product?.promoPrice ||
                        product?.OnlineSelingPrice ||
                        product?.sellingPrice) -
                    product?.installingPrice);
            total +=
                product.installing *
                (product?.promoPrice ||
                    product?.OnlineSelingPrice ||
                    product?.sellingPrice);
        }
        else {
            total +=
                product.count *
                (product?.haveInstalling && !product.installing
                    ? (product?.promoPrice ||
                    product?.OnlineSelingPrice ||
                    product?.sellingPrice) - product.installingPrice
                    : product?.promoPrice ||
                    product?.OnlineSelingPrice ||
                    product?.sellingPrice);
        }
        return count + total;
    }, 0);

    if (!isOpen) return null;

    return (
        <div className={styles.mobile_cart_container}>
            <div className={styles.mobile_cart_products_box}>
                <div className={styles.header_cart_top_box}>
                    <span style={{fontWeight: "bold"}}>
                        {langData.buttons.cart[currentLanguage]}
                    </span>
                    <span>
                        {shopCartCount?.count + ' '}
                            {langData.prod[currentLanguage]}
                    </span>
                </div>
                {
                    (!products || products?.length === 0) ?
                        <div className={styles.empty_cart_content}>
                            <img
                                className="ls-is-cached lazyloaded"
                                data-src="https://vlv.am/public/img/empty.svg" alt=""
                                src="https://vlv.am/public/img/empty.svg"
                                style={{
                                    width: "100px",
                                }}
                            />
                            {lang[currentLanguage].your_cart_is_empty_please_select_item_s_before_checkout}
                        </div>
                        :
                        products?.map((product, index) => {
                            return (
                                <MobileFooterCartProduct
                                    key={index}
                                    product={product}
                                    setProduct={(newState) => {
                                        let productsArray = products?.map((item) => {
                                            if (item.id === product.id) {
                                                return newState;
                                            }
                                            return item;
                                        });
                                        setProducts(productsArray);
                                    }}
                                    deleteProduct={() => {
                                        dispatch(
                                            setCartPageDelete({
                                                id: product.cartId,
                                            })
                                        );
                                        dispatch(setShopCartCount(
                                            {
                                                count: shopCartCount?.count - 1,
                                                price: shopCartCount.price - (+product?.promo_price || +product?.OnlineSelingPrice || +product?.sellingPrice)
                                            }
                                        ))
                                        let productsArray = products.filter(
                                            (item) => item.id !== product.id
                                        );
                                        setProducts(productsArray);
                                    }}
                                />
                            );
                        })
                }
            </div>
            <div className={styles.mobile_cart_button_box}>
                <div className={styles.mobile_cart_total_box}>
                    <span>{lang[currentLanguage].total}</span>
                    <span>{UseCalcPrice(totalPrice, currentCurrency)}</span>
                </div>
                <div className={styles.mobile_cart_button}>
                {
                    (products && products?.length > 0) ?
                        <button
                            onClick = {() => {
                                navigate(`${currentLanguage !== "hy" ? "/" + currentLanguage : ""}/cart`)
                                setIsOpen(false);
                            }}
                        >
                            { langData.buttons.to_cart[currentLanguage] }
                        </button>
                        :
                        null
                }
                </div>
            </div>
        </div>
    )
}

export default MobileFooterCart;